export const notificationActionTypes = {
  TOGGLE_ALERT: "TOGGLE_ALERT",
  SHOW_SUCCESS: "SHOW_SUCCESS",
  SHOW_ERROR: "SHOW_ERROR",
};
